import useUserAccountInfo from '@/queries/useUserAccountInfo';

interface IsPrimeUserLoggedProps {
  isPrimeUserLogged: boolean;
  loadingUserAccountInfo: boolean;
}

const useIsPrimeUserLogged = (): IsPrimeUserLoggedProps => {
  const { data: dataUserAccountInfo, loading: loadingUserAccountInfo } =
    useUserAccountInfo();
  const isActivePrimeMember =
    dataUserAccountInfo?.userAccount?.userMembership.isActive || false;
  const isLoggedIn = dataUserAccountInfo?.userAccount?.isLoggedIn || false;

  return {
    isPrimeUserLogged: isLoggedIn && isActivePrimeMember,
    loadingUserAccountInfo,
  };
};

export default useIsPrimeUserLogged;
